import {
  Button,
  Divider,
  Col,
  Row,
  Layout,
  Breadcrumb,
  Dropdown,
  Menu,
  Pagination,
  Steps,
  AutoComplete,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Switch,
  Upload,
  Badge,
  Descriptions,
  Empty,
  Popover,
  Popconfirm,
  Table,
  Tabs,
  Collapse,
  Tag,
  Tooltip,
  Modal,
  Progress,
  Result,
  Skeleton,
  Spin,
  BackTop,
  ConfigProvider,
  Image,
  Space,
  Comment,
  List,
  Mentions,
  Drawer,
} from 'ant-design-vue'

const components = [
  List,
  Button,
  Col,
  Row,
  Divider,
  Layout,
  Breadcrumb,
  Dropdown,
  Menu,
  Pagination,
  Steps,
  AutoComplete,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Switch,
  Upload,
  Badge,
  Descriptions,
  Empty,
  Popover,
  Popconfirm,
  Table,
  Tabs,
  Collapse,
  Tag,
  Tooltip,
  Modal,
  Progress,
  Result,
  Skeleton,
  Spin,
  BackTop,
  ConfigProvider,
  Image,
  Space,
  Comment,
  Mentions,
  Drawer,
]

export default components
